import { emailOnlyRequestSchema, type EmailOnlyRequest } from '@koderek/shared';
import { zodResolver } from '@hookform/resolvers/zod';
import { Alert, Button, Stack, TextInput } from '@mantine/core';
import { useMutation } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { api } from '../../api/client';
import { t } from '../../texts/pl';
import { errorMessage } from './session';

/** US-203: ponowne wysłanie linku; odpowiedź zawsze ta sama (AC-2). */
export function ResendActivation({ defaultEmail = '' }: { defaultEmail?: string }) {
  const form = useForm<EmailOnlyRequest>({ resolver: zodResolver(emailOnlyRequestSchema), defaultValues: { email: defaultEmail } });
  const resend = useMutation({ mutationFn: (body: EmailOnlyRequest) => api('POST', '/auth/resend-activation', { body }) });

  if (resend.isSuccess) {
    return (
      <Alert color="green" role="status">
        {t.resend.done}
      </Alert>
    );
  }
  return (
    <form onSubmit={form.handleSubmit((values) => resend.mutate(values))} noValidate>
      <Stack gap="sm">
        <TextInput
          label={t.fields.email}
          type="email"
          autoComplete="email"
          {...form.register('email')}
          error={form.formState.errors.email?.message}
        />
        {resend.isError ? (
          <Alert color="red" role="alert">
            {errorMessage(resend.error)}
          </Alert>
        ) : null}
        <Button type="submit" variant="light" loading={resend.isPending}>
          {t.resend.submit}
        </Button>
      </Stack>
    </form>
  );
}
